/** The texts of education (EDU-*), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const educationEn = {
  education: 'Education',
  educationIntro: 'Practise reading on released cases: mark what you see, submit, and compare with the reference agreed by several readers.',
  notCleared: 'You are not cleared for education yet. An educator clears learners.',
  learningTerms: 'Terms for learners',
  acceptLearningTerms: 'Accept and start',
  caseSets: 'Case sets',
  noCaseSets: 'No case sets are offered yet.',
  caseSetBy: 'by {name}',
  casesAnswered: '{answered} of {cases} cases read',
  startQuiz: 'Start',
  continueQuiz: 'Continue',
  bodyRegions: 'Body regions',
  allBodyRegions: 'All regions',
  unknownRegion: 'Unknown',
  submitCase: 'Submit',
  nextCase: 'Next case',
  quizEyebrow: 'LEARNING',
  allCasesRead: 'You have read every case of this selection.',
  caseFacts: '{sex} · {age} · {part}',
  feedback: 'Feedback',
  outcome_found: 'Found',
  outcome_missed: 'Missed',
  outcome_false: 'False',
  outcome_disputed: 'Disputed',
  feedbackCounts: '{found} found · {missed} missed · {false} false',
  noFindingsHere: 'The reference has no finding here.',
  yourMarks: 'Your marks',
  educators: 'Educators',
  learners: 'Learners',
  clearLearner: 'Clear a learner',
  makeEducator: 'Make an educator',
  clearForEducation: 'Clear',
  learnerListTitle: 'Clear a list of learners',
  learnerList: 'Learners',
  learnerListHint: 'One per line: e-mail, first name, last name, separated by commas, semicolons or tabs, as a spreadsheet copies them.',
  learnerListInvalid: 'Not a learner on line {lines}: an e-mail address, a first and a last name are needed.',
  learnerListSend: 'Clear {count} learners',
  termsPending: 'terms not accepted yet',
  teaching: 'Teaching',
  teachingIntro: 'Released for teaching, every resolved study becomes a case, with its resolution as the reference. Each site decides by its teaching policy.',
  releaseForTeaching: 'Release for teaching',
  endTeachingRelease: 'End the release',
  releasedCases: 'Released {date}: {cases} cases',
  teachingPolicy: 'Teaching with this site’s images',
  teachingPolicy_allowed: 'Allowed',
  teachingPolicy_approval: 'Each release needs approval',
  teachingPolicy_forbidden: 'Not allowed (withdraws all cases)',
  approval_pending: 'Waiting for approval',
  approval_approved: 'Approved',
  approval_refused: 'Refused',
  noTeachingReleases: 'No release holds this site’s images.',
  offerForTeaching: 'Offer to learners as a case set',
  caseSetLabels: 'Findings learners mark',
  caseSetOffered: 'Offered to learners: {cases} cases',
  stopOffering: 'Stop offering',
  caseSetHint: 'The case set holds the released cases that match this collection’s filters. Learners’ answers in it go when it is no longer offered.',
  courses: 'Courses',
  coursesNone: 'No course yet.',
  courseCreate: 'Create a course',
  courseTitle: 'Title',
  courseLanguage: 'Language',
  courseStarts: 'From',
  courseEnds: 'To',
  courseRetention: 'Readings kept until',
  courseRetentionHint: 'Then the learners’ readings in the course are deleted; its statistics stay.',
  coursePeriod: '{from} to {to}',
  courseRunning: 'Running',
  courseNotRunning: 'Not running',
  courseReadingsDeleted: 'The learners’ readings were deleted at the end of the retention period.',
  courseEducatorAdd: 'Add an educator',
  courseEducatorEmail: 'E-mail of an educator',
  courseLearners: '{count} learners',
  courseLearners_one: '1 learner',
  courseInvite: 'Invite learners',
  courseCaseSets: 'Case sets of the course',
  courseCaseSetsHint: 'Offer a collection in this course on the collection’s page, as practice or as an assessment.',
  courseResults: 'Results',
  courseResearchExport: 'Research export (CSV)',
  courseResearchHint: 'Only the learners who agreed, under pseudonyms.',
  courseReport: 'Funding report',
  courseReportDownload: 'Download the report (JSON)',
  courseReportSummary: '{cases} cases read · {hours} hours',
  courseLearningEffect: 'Learning effect, {count} learners: sensitivity {sensitivity}, specificity {specificity}',
  researchUse: 'Research use',
  whereYouTrain: 'Where you train',
  whereYouTrainHint: 'For the course statistics, if you belong to no site on the platform: your institution and its country (two letters, for example AT).',
  trainingInstitution: 'Institution',
  countryCode: 'Country',
  researchConsent: 'My pseudonymized results may be used for educational research.',
  researchConsentHint: 'You can withdraw this at any time; research exports then leave your results out.',
  assessment: 'Assessment',
  stage_entry: 'Entry assessment',
  stage_final: 'Final assessment',
  caseSetCourse: 'Course',
  caseSetNoCourse: 'None: practice for every learner',
  caseSetAssessment: 'Assessment: feedback after the last case, taken once',
  caseSetStage: 'Measures the learning effect as',
  stageNone: 'Neither',
  assessmentRecorded: 'Answer recorded. The feedback follows the last case.',
  assessmentReview: 'Review my answers',
  courseAverage: 'Course average',
  courseIsNotRunning: 'The course is not running now.',
  learnerPseudonym: 'Pseudonym',
  researchAgreed: 'agrees to research use',
  minutesCount: '{count} min',
  casesReadCount: '{count} cases read',
  casesReadCount_one: '1 case read',
  courseEdit: 'Change the course',
  teachingNotes: 'Teaching notes',
  teachingNote: 'Teaching note',
  teachingNoteHint: 'Click on an image to place a numbered marker, and refer to it by its number in the note.',
  noteUndoMarker: 'Remove the last marker',
  noteRemove: 'Remove the note',
  modelSuggestionsOf: 'Suggestions of {model}',
  caseSetModel: 'Model suggestions in the feedback',
  caseSetNoModel: 'None',
} as const

export const educationDe: Record<keyof typeof educationEn, string> = {
  education: 'Lehre',
  educationIntro: 'Üben Sie das Befunden an freigegebenen Fällen: Markieren Sie, was Sie sehen, reichen Sie ein und vergleichen Sie mit der Referenz, auf die sich mehrere Lesende geeinigt haben.',
  notCleared: 'Sie sind noch nicht für die Lehre freigeschaltet. Lehrende schalten Lernende frei.',
  learningTerms: 'Bedingungen für Lernende',
  acceptLearningTerms: 'Akzeptieren und beginnen',
  caseSets: 'Fallsammlungen',
  noCaseSets: 'Noch werden keine Fallsammlungen angeboten.',
  caseSetBy: 'von {name}',
  casesAnswered: '{answered} von {cases} Fällen gelesen',
  startQuiz: 'Beginnen',
  continueQuiz: 'Fortsetzen',
  bodyRegions: 'Körperregionen',
  allBodyRegions: 'Alle Regionen',
  unknownRegion: 'Unbekannt',
  submitCase: 'Einreichen',
  nextCase: 'Nächster Fall',
  quizEyebrow: 'LERNEN',
  allCasesRead: 'Sie haben jeden Fall dieser Auswahl gelesen.',
  caseFacts: '{sex} · {age} · {part}',
  feedback: 'Rückmeldung',
  outcome_found: 'Gefunden',
  outcome_missed: 'Übersehen',
  outcome_false: 'Falsch',
  outcome_disputed: 'Strittig',
  feedbackCounts: '{found} gefunden · {missed} übersehen · {false} falsch',
  noFindingsHere: 'Die Referenz hat hier keinen Befund.',
  yourMarks: 'Ihre Markierungen',
  educators: 'Lehrende',
  learners: 'Lernende',
  clearLearner: 'Lernende freischalten',
  makeEducator: 'Zur lehrenden Person machen',
  clearForEducation: 'Freischalten',
  learnerListTitle: 'Eine Liste Lernender freischalten',
  learnerList: 'Lernende',
  learnerListHint: 'Eine Person pro Zeile: E-Mail, Vorname, Nachname, getrennt durch Kommas, Semikolons oder Tabulatoren, wie eine Tabelle sie kopiert.',
  learnerListInvalid: 'Keine lernende Person in Zeile {lines}: E-Mail-Adresse, Vor- und Nachname werden gebraucht.',
  learnerListSend: '{count} Lernende freischalten',
  termsPending: 'Bedingungen noch nicht akzeptiert',
  teaching: 'Lehre',
  teachingIntro: 'Für die Lehre freigegeben, wird jede aufgelöste Studie ein Fall, mit ihrer Auflösung als Referenz. Jeder Standort entscheidet nach seiner Lehrrichtlinie.',
  releaseForTeaching: 'Für die Lehre freigeben',
  endTeachingRelease: 'Freigabe beenden',
  releasedCases: 'Freigegeben am {date}: {cases} Fälle',
  teachingPolicy: 'Lehre mit Bildern dieses Standorts',
  teachingPolicy_allowed: 'Erlaubt',
  teachingPolicy_approval: 'Jede Freigabe braucht eine Zustimmung',
  teachingPolicy_forbidden: 'Nicht erlaubt (zieht alle Fälle zurück)',
  approval_pending: 'Wartet auf Zustimmung',
  approval_approved: 'Zugestimmt',
  approval_refused: 'Abgelehnt',
  noTeachingReleases: 'Keine Freigabe enthält Bilder dieses Standorts.',
  offerForTeaching: 'Lernenden als Fallsammlung anbieten',
  caseSetLabels: 'Befunde, die Lernende markieren',
  caseSetOffered: 'Lernenden angeboten: {cases} Fälle',
  stopOffering: 'Nicht mehr anbieten',
  caseSetHint: 'Die Fallsammlung enthält die freigegebenen Fälle, die zu den Filtern dieser Sammlung passen. Antworten von Lernenden darin gehen verloren, wenn sie nicht mehr angeboten wird.',
  courses: 'Kurse',
  coursesNone: 'Noch kein Kurs.',
  courseCreate: 'Kurs erstellen',
  courseTitle: 'Titel',
  courseLanguage: 'Sprache',
  courseStarts: 'Von',
  courseEnds: 'Bis',
  courseRetention: 'Befundungen aufbewahrt bis',
  courseRetentionHint: 'Danach werden die Befundungen der Lernenden im Kurs gelöscht; seine Statistik bleibt.',
  coursePeriod: '{from} bis {to}',
  courseRunning: 'Läuft',
  courseNotRunning: 'Läuft nicht',
  courseReadingsDeleted: 'Die Befundungen der Lernenden wurden am Ende der Aufbewahrungsfrist gelöscht.',
  courseEducatorAdd: 'Lehrperson hinzufügen',
  courseEducatorEmail: 'E-Mail einer Lehrperson',
  courseLearners: '{count} Lernende',
  courseLearners_one: '1 lernende Person',
  courseInvite: 'Lernende einladen',
  courseCaseSets: 'Fallsammlungen des Kurses',
  courseCaseSetsHint: 'Bieten Sie eine Sammlung auf ihrer Seite in diesem Kurs an, zum Üben oder als Prüfung.',
  courseResults: 'Ergebnisse',
  courseResearchExport: 'Forschungsexport (CSV)',
  courseResearchHint: 'Nur die Lernenden, die zugestimmt haben, unter Pseudonymen.',
  courseReport: 'Bericht für Förderprogramme',
  courseReportDownload: 'Bericht herunterladen (JSON)',
  courseReportSummary: '{cases} Fälle gelesen · {hours} Stunden',
  courseLearningEffect: 'Lerneffekt, {count} Lernende: Sensitivität {sensitivity}, Spezifität {specificity}',
  researchUse: 'Forschungsnutzung',
  whereYouTrain: 'Wo Sie sich ausbilden',
  whereYouTrainHint: 'Für die Kursstatistik, wenn Sie keinem Standort der Plattform angehören: Ihre Einrichtung und ihr Land (zwei Buchstaben, etwa AT).',
  trainingInstitution: 'Einrichtung',
  countryCode: 'Land',
  researchConsent: 'Meine pseudonymisierten Ergebnisse dürfen für die Lehrforschung verwendet werden.',
  researchConsentHint: 'Sie können das jederzeit widerrufen; Forschungsexporte lassen Ihre Ergebnisse dann aus.',
  assessment: 'Prüfung',
  stage_entry: 'Eingangsprüfung',
  stage_final: 'Abschlussprüfung',
  caseSetCourse: 'Kurs',
  caseSetNoCourse: 'Keiner: zum Üben für alle Lernenden',
  caseSetAssessment: 'Prüfung: Rückmeldung nach dem letzten Fall, nur einmal',
  caseSetStage: 'Misst den Lerneffekt als',
  stageNone: 'Keine',
  assessmentRecorded: 'Antwort gespeichert. Die Rückmeldung folgt nach dem letzten Fall.',
  assessmentReview: 'Meine Antworten ansehen',
  courseAverage: 'Kursdurchschnitt',
  courseIsNotRunning: 'Der Kurs läuft gerade nicht.',
  learnerPseudonym: 'Pseudonym',
  researchAgreed: 'stimmt der Forschung zu',
  minutesCount: '{count} min',
  casesReadCount: '{count} Fälle gelesen',
  casesReadCount_one: '1 Fall gelesen',
  courseEdit: 'Kurs ändern',
  teachingNotes: 'Lehrnotizen',
  teachingNote: 'Lehrnotiz',
  teachingNoteHint: 'Klicken Sie in ein Bild, um eine nummerierte Markierung zu setzen, und nennen Sie sie in der Notiz bei ihrer Nummer.',
  noteUndoMarker: 'Letzte Markierung entfernen',
  noteRemove: 'Notiz entfernen',
  modelSuggestionsOf: 'Vorschläge von {model}',
  caseSetModel: 'Modellvorschläge in der Rückmeldung',
  caseSetNoModel: 'Keine',
}
